<template>
  <div>
    <div v-for="route in permission_routes" :key="route.path" :class="['item',{'active':$route.path== route.path}]">
      <a @click="navigateTo(route.path)">
        <div class="icon">
          <svg-icon :icon-class="route.meta.icon" />
        </div>
        <div class="title">{{ generateTitle(route.meta.title) }}</div>
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { generateTitle } from '@/utils/i18n'

export default {
  name: 'SidebarItem',
  data() {
    return {

    }
  },
  computed: {
    ...mapGetters([
      'permission_routes'
    ])
  },
  methods: {
    generateTitle,
    navigateTo(url) {
      this.$router.push(url)
    }
  }
}
</script>

<style scoped>
   .item{
     padding: 15px;
     text-align: center;
     cursor: pointer;
   }
   .item .icon .svg-icon{
        width: 20px !important;
        height: 20px !important;
        color: rgba(255, 255, 255, 0.65);
    }
    .item.active .icon .svg-icon{
        color: #fff;
    }
    .item:hover .icon .svg-icon{
        color: #fff;
    }
    .item .title{
      line-height: 30px;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.65);
    }
    .item.active .title{
      color:#fff;
    }
    .item:hover .title{
      color:#fff;
    }
</style>
